import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Policy from '@/components/Policy'
import Register from '@/components/Register'
import Success from '@/components/Success'
import Recovery from '@/components/Recovery'
import Modify from '@/components/Modify'
import Payment from '@/components/Payment/Index'
import Unsubscribe from '@/components/Unsubscribe'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      meta:{
        title:'首頁',
      }
    },
    {
      path: '/policy',
      name: 'Policy',
      component: Policy,
      meta:{
        title:'服務政策',
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta:{
        title:'會員注冊',
      }
    },
    {
      path: '/success',
      name: 'Success',
      component: Success,
      meta:{
        title:'成功',
      }
    },
    {
      path: '/recovery',
      name: 'Recovery',
      component: Recovery,
      meta:{
        title:'找回密碼',
      }
    },    
    {
      path: '/modify',
      name: 'Modify',
      component: Modify,
      meta:{
        title:'修改密碼',
      }
    },    
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: Unsubscribe,
      meta:{
        title:'取消訂閲',
      }
    },
    {
      path: '/payment/index',
      name: 'Payment',
      component: Payment,
      meta:{
        title:'在線儲值',
      }
    },  
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js